// extracted by mini-css-extract-plugin
export default {"ArticleMedia":"ArticleMedia_TyQhd","ArticleMedia_caption":"ArticleMedia_caption_Dv1F7","ArticleMedia_mediabox":"ArticleMedia_mediabox_NwTFO"};